import { buildEnvironment } from "../config/build-environment"

export const apiEndPoints = {
  facilities: getBaseUrl() + "/v1/facilities",
  facilityVisit: getBaseUrl() + "/v1/facility-visit",
  fetchAppointment: getBaseUrl() + "/v1/fetch-appointment",
  activities: getBaseUrl() + "/v1/visits/",
  files: getFileIdBaseUrl() + "/api/v1/tracking/",
  resendNotification: getBaseUrl() + "/v1/resend-notification",
  assignDriver: getAssignDriverBaseUrl() + "/loads/v1/assign-driver",
  getEdocsUrl: getEdocsIframeUrl() + "/edocs/#/flash-pass-edocs?data=",
  fetchYard: getBaseUrl() + "/v1/fetch-yard",
  fetchEdocs: getBaseUrl() + "/v1/fetch-edocs",
  fetchSummary: getBaseUrl() + "/v1/fetch-summary",
  fetchDirection: getBaseUrl() + "/v1/direction-details",
  submitassetsinfo: getBaseUrl() + "/v1/assets-info",
  searchCarrier: getBaseUrl() + "/v1/search-carrier",
  inviteCarrier: getBaseUrl() + "/v1/invite-carrier",
  fetchCarrierDetails: getBaseUrl() + "/v1/fetch-carrier-details",
  fetchReferenceDetails: getBaseUrl() + "/v1/fetch-reference-details"
}

function getBaseUrl() {
  switch (buildEnvironment) {
    case "prod":
      return "https://driver-experience.fourkites.com"
    case "local":
      return "http://localhost:5000"
    default:
      return `https://driver-experience-${buildEnvironment}.fourkites.com`
  }
}
function getFileIdBaseUrl() {
  switch (buildEnvironment) {
    case "prod":
      return "https://tracking-api.fourkites.com"
    case "local":
      return "http://localhost:5000"
    default:
      return `https://tracking-api-${buildEnvironment}.fourkites.com`
  }
}

function getAssignDriverBaseUrl() {
  switch (buildEnvironment) {
    case "prod":
      return "https://ebol-service.fourkites.com"
    case "local":
      return "http://localhost:5000"
    default:
      return `https://ebol-service-${buildEnvironment}.fourkites.com`
  }
}

function getEdocsIframeUrl() {
  switch (buildEnvironment) {
    case "prod":
      return "https://app.fourkites.com"
    case "local":
      return "http://localhost:5000"
    default:
      return `https://app-${buildEnvironment}.fourkites.com`
  }
}
